module.exports = __webpack_public_path__ + "img/home_img2.a52e9989.png";